import React, { useEffect, useRef, useState } from 'react';
import { Camera } from "react-camera-pro";

export const WebcamCapture = ({ openCamera, handleUpload }) => {
    const camera = useRef(null);
    const [image, setImage] = useState(null);

    async function handleTakePhotoAnimationDone(dataUri) {
        console.log('takePhoto');
        // Just build a File from the capture — compression happens centrally in
        // uploadViaPresignedUrl (same for camera, file-picker and dropzone).
        const blob = await fetch(dataUri).then((res) => res.blob());
        let imageurl = URL.createObjectURL(blob);
        let name = Math.random() + "." + (blob.type.split("/")[1] || "jpg");
        const myFile = new File([blob], name, { type: blob.type || "image/jpeg" });
        console.log(myFile, imageurl, '/......')
        handleUpload(myFile, imageurl)
    }

    useEffect(() => {
        if (image) {
            handleTakePhotoAnimationDone(image)
        }
    }, [image])

    return (
        <>
            <Camera ref={camera} />
            <button onClick={() => setImage(camera.current.takePhoto())}>Take photo</button>
        </>
    );
};
